import { faUsers } from '@fortawesome/pro-regular-svg-icons';
import { EmptyState } from '@client/new/components/EmptyState/EmptyState';

export const EmptyCommunities = () => (
  <EmptyState
    icon={faUsers}
    captionLine1="Create your first community"
    captionLine2="Start a space for your audience"
  />
);
